import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Router } from "@angular/router";
import { DataService } from "./data.service";
import { OAuthService } from "angular-oauth2-oidc";
import { AuthService } from "src/app/auth.service";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private route: Router, private dataService: DataService, private oAuthSvc: OAuthService, private auth: AuthService) {}
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.oAuthSvc.hasValidIdToken() && this.oAuthSvc.hasValidAccessToken()) {
      return true;
    }
    const token = this.auth.getAccessToken();
    const refresh = this.auth.getRefreshToken();

    if (token) {
      return true;
    }
    localStorage.clear();
    sessionStorage.clear();
    this.route.navigate(["signin"]).then(() => {
      console.log("reload called");
      document.location.reload();
    });
    return false;
  }
}
